import { configureStore } from '@reduxjs/toolkit';

import { allStudentSlices } from './StudentSlices/allStudentSlices';


export const store = configureStore({
  reducer: {
    ...allStudentSlices
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
